import { IntegrationsStatus } from "@/generated";
import { InboxUseCaseConfig, InboxSourceConfig, InboxSource } from "./types";

export const INBOX_SOURCES: InboxSourceConfig[] = [
  {
    id: "gmail",
    name: "Gmail",
    description: "Connect your Gmail account",
    icon: "https://storage.googleapis.com/image-storage-spot-manual/logos/gmail.svg",
    integration: "gmail",
    conversational: true,
    comingSoon: true,
    category: "external",
  },
  {
    id: "outlook",
    name: "Outlook",
    description: "Connect your Outlook account",
    icon: "https://storage.googleapis.com/image-storage-spot-manual/logos/outlook.png",
    integration: "outlook",
    conversational: true,
    comingSoon: true,
    category: "external",
  },
  {
    id: "noxus",
    name: "Noxus inbox",
    description: "Get a dedicated email address instantly",
    icon: "https://storage.googleapis.com/image-storage-spot-manual/app/sidenav/noxus-o.svg",
    conversational: true,
    comingSoon: false,
    category: "noxus",
    hasConfiguration: true,
  },
];

export const isSourceConnected = (
  source: InboxSource | null,
  integrations: IntegrationsStatus | null
): boolean => {
  if (!source) return false;
  const sourceConfig = INBOX_SOURCES.find(
    (s: InboxSourceConfig) => s.id === source
  );
  if (!sourceConfig?.integration) return true;
  if (!integrations) return false;
  return (
    integrations[sourceConfig.integration as keyof IntegrationsStatus] === true
  );
};

export const INBOX_USE_CASES: InboxUseCaseConfig[] = [
  {
    id: "customer_enquiries",
    name: "Too many inquiries slipping through the cracks?",
    description:
      "Organize, prioritize, and draft responses to keep every customer acknowledged.",
    icon: "Ticket",
    iconBg: "bg-red-50",
    iconColor: "text-red-900",
  },
  {
    id: "document_extraction",
    name: "Spending too much time processing invoices?",
    description:
      "Automatically extract and structure data from PDF's, emails, and invoices into your ERP system",
    icon: "ScanText",
    iconBg: "bg-pink-50",
    iconColor: "text-pink-900",
    comingSoon: true,
  },
  {
    id: "email_triage",
    name: "Drowning in incoming emails & tickets?",
    description:
      "Automatically sort, prioritize and route each request to the right team so nothing gets missed.",
    icon: "NotebookPen",
    iconBg: "bg-purple-50",
    iconColor: "text-purple-800",
    comingSoon: true,
  },
];
